
import { defineComponent } from "vue";

export default defineComponent({
  name: "ContactDetailItem",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
});
